<template>
    <v-data-table
      disable-sort
			:headers="headers"
			:items="c_items"
      disable-pagination
			class="tablaLT1"
			:class="dark_t?'dark':''">
    <template v-slot:item.critical="{ value }">
      <v-icon color="#00b007" v-if="value">check</v-icon>
      <v-icon color="#f90000" v-else>cancel</v-icon>
    </template>
    <template v-slot:item.ebit="{ value }">
      <div class="align_right">{{fix(ebit)}}</div>
    </template>
    <template v-slot:item.ct_financial_loss="{ value }">
      <div class="align_right">{{value}}</div>
    </template>
    <template v-slot:item.mfl_financial="{ value }">
      <div class="align_right">{{value}}</div>
    </template>
    <template v-slot:item.mfl_health_and_safety="{ value }">
      <div class="align_right">{{value}}</div>
    </template>
    <template v-slot:item.mfl_environment="{ value }">
      <div class="align_right">{{value}}</div>
    </template>
    <template v-slot:item.mfl_community="{ value }">
      <div class="align_right">{{value}}</div>
    </template>
    <template v-slot:item.mfl_legal="{ value }">
      <div class="align_right">{{value}}</div>
    </template>
    </v-data-table>
</template>
<script>
export default {
  props:['items','ebit'],
  data(){
    return {
      
    }
  },
  computed: {
    headers() {
			let hs = [
				{ text: '#', value: '#' },
				{ text: 'Modo de Falla', value: 'catastrophic_fail', class:['text_align_left'] },
        { text: 'EBITDA', value: 'ebit' },
				{ text: 'Cálculo MFL Financiero', value: 'ct_financial_loss' },
				{ text: 'MFL Financiero', value: 'mfl_financial' },
				{ text: 'MFL H&S', value: 'mfl_health_and_safety', class:[''] },
				{ text: 'MFL Medioambiente', value: 'mfl_environment' },
				{ text: 'MFL Comunidad', value: 'mfl_community' },
				{ text: 'MFL Reputación/Legal', value: 'mfl_legal' },
				{ text: 'Criticidad', value: 'critical', cellClass:['width100px','text_align_center'],align:'center'},
			];
			return hs
    },
    c_items(){
      const c_items = [];
      this.items.forEach((item,i) => {
      const ebit = Math.max.apply(Math,item.impacted_area_details.map(clc => clc.ebit||0));
        const {catastrophic_fail,mfl_legal,mfl_community,mfl_environment,mfl_health_and_safety,mfl_financial} = item;
        const c_item = {
          '#':`${(i+1)}`,
          ebit:this.fix(ebit),
          
          ct_financial_loss: this.ct_financial_loss(item),
          catastrophic_fail,
          mfl_legal,
          mfl_community,
          mfl_environment,
          mfl_health_and_safety,
          mfl_financial,
          critical:mfl_health_and_safety >= 4 || mfl_environment >= 4 || mfl_community >= 4 || mfl_legal >= 4 || mfl_financial >= 3,
        };          
        c_items.push(c_item)        
      });
      return c_items;
    }
  },
  methods: {
    ct_financial_loss(item){
      /* da '-infinito' si el array es '[]'  */
      const max_slc_fl = item.static_loss_compositions.length
        ? Math.max.apply(Math,item.static_loss_compositions.map(m=>m.financial_loss))
        : 0;
      return parseInt(max_slc_fl+item.financial_loss)
    },
  },
};
</script>
